<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-row  justify="center">
  <v-col>
    <v-card>
      <v-card-text>
      <h2 class="font-weight-light mb-4">
          {{$t("workTypes.show.header")}}
        </h2>

        <v-row>
          <v-col>
            <v-btn
              :to="{ name: 'WorkTypeEdit', params: { 'id': id }}">
              {{$t("workTypes.show.edit")}}
            </v-btn>

          </v-col>
        </v-row>

        <v-row align="end">
          <v-col cols="1" md="3">
            <div class="h2">
            {{$t('workType.name')}}:
            </div>
          </v-col>
          <v-col cols="8">
            <div class="h2">
            {{workTypeName}}
            </div>
          </v-col>
        </v-row>


      </v-card-text>

    </v-card>
  </v-col>
    </v-row>


    <v-row>
      <v-col>
      <h2 class="font-weight-light mb-4">
        {{$t('workOperations.list.title')}}
      </h2>
      </v-col>
    </v-row>


    <v-row>
      <v-col cols="10">
        <v-text-field

          :label="$t('global.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <material-card
          :title="$t('workOperations.list.title')"
        >

          <v-data-table
            :headers="headers"
            :items="workOperations"
            :search="search"
            @click:row="editWorkOperation"
            hide-default-footer
            :items-per-page="1000"
          >
            <template v-slot:item.delete="{ item }">
              <v-icon v-if="item.deleteable" @click.stop="openDeleteDialogue(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>


    </v-row>

    <v-dialog
      v-model="deletedialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{$t("workOperations.list.delete.header")}}</v-card-title>

        <v-card-text>
          {{$t("workOperations.list.delete.body")}}
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn
            text
            @click="closeDelete"
          >
            {{$t("global.deleteDialogue.cancel")}}
          </v-btn>

          <v-btn
            color="success"
            text
            @click="confirmDelete"
          >
            {{$t("global.deleteDialogue.confirm")}}
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-row>
      <v-col>
        <v-btn
          :to="{ name: 'WorkOperationCreate', params: { 'workTypeId': id }}">
          {{$t("workOperations.list.create")}}
        </v-btn>
      </v-col>

    </v-row>

  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'

    export default {
        data() {
            return {
                deletedialog: false,
                deleteId:0,
                id:"",
                workTypeName: "",
                search: '',
                headers: [
                    {
                        sortable: true,
                        text: this.$i18n.t("workOperation.name"),
                        value: 'name'
                    },
                    {       sortable: false,
                        text: this.$i18n.t("global.delete"),
                        value: 'delete'
                    }
                ],
                workOperations: []

            }
        },
        methods: {
            getWorkType(workTypeid) {
                api.getWorkType(workTypeid).then(response => {
                    this.id = response.id
                    this.workTypeName= response.name
                    this.getWorkOperations(response.id)

            })
                .catch(error => {
                     this.$store.commit('setErrorMsg', error)
                        console.log(error)
                    //    this.errors.push(error)
                })
            },
            getWorkOperations (workTypeId) {
                api.getWorkOperations(workTypeId).then(response => {
                    this.workOperations = response
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            editWorkOperation (rowdata) {
                this.$router.push({ path: '/workOperationEdit/' + rowdata.id })
            },
            openDeleteDialogue(id) {
                this.deletedialog = true
                this.deleteId = id
            },
            confirmDelete() {

                api.deleteWorkOperation(this.deleteId).then(response => {
                    this.deletedialog = false
                    this.getWorkOperations(this.id);
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                    })



            },
            closeDelete() {
                this.deleteId =0
                this.deletedialog = false
            }


        },
        mounted() {
           this.getWorkType(this.$route.params.id)
        }
    }
</script>
